/**
 * Can update modal display via ModalActions
 * ex: this.props.dispatch(ModalActions.updateDisplayEnableApplicationsModal({ isOpen: true }))
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Modal from '@zg-rentals/multibrand-ui/lib/Modal';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// actions
import ModalActions from 'app/shared/actions/ModalActions';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import ListingActivationTerms from 'app/shared/components/ListingActivationTerms';
import ModalConstants from 'app/shared/constants/ModalConstants';

// Selectors
import { ModalSelectors } from 'app/shared/selectors';

// style
import './style.scss';

const propTypes = {
    isOpen: PropTypes.bool,
    // actions
    handleConfirmClick: PropTypes.func,
};

const defaultProps = {
    isOpen: false,
    handleConfirmClick: () => {},
};

class EnableApplicationsModal extends React.Component {
    constructor(props) {
        super(props);

        // init state
        this.state = { isOpen: this.props.isOpen };

        // bind
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.modalClose = this.modalClose.bind(this);
        this.modalOpen = this.modalOpen.bind(this);
    }

    // TODO: abstract function
    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen !== this.state.isOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    }

    handleConfirmClick() {
        this.props.dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.APPLICATIONS_MODAL_ENABLE));
        this.props.handleConfirmClick();
    }

    modalClose() {
        this.props.dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.APPLICATIONS_MODAL_DISMISS));
        this.props.dispatch(ModalActions.updateDisplayEnableApplicationsModal({ isOpen: false }));
    }

    modalOpen() {
        this.props.dispatch(ModalActions.updateDisplayEnableApplicationsModal({ isOpen: true }));
    }

    render() {
        const { isOpen } = this.state;
        const buttonTitle = 'Enable applications';

        // content
        const header = 'ENABLE APPLICATIONS';
        const title = 'Simplify your rental process.';
        const p1 = 'By enabling applications, renters on Zillow, Trulia and HotPads will be able to apply directly ' +
            'from your active rental listings.';
        const p2 = 'You can also invite specific renters to apply for any of your properties.';
        const parentSelector = ModalConstants.MODAL_PARENT_SELECTOR;

        return (
            <Modal
                className="EnableApplicationsModal"
                header={header}
                hideBackButton={true}
                isOpen={isOpen}
                isWizard={true}
                id={parentSelector}
                shouldBypassBodyStyling={true}
                onRequestClose={this.modalClose}
            >
                <div className="EnableApplicationsModal-Content">
                    <Text className="Content-Header" type="h4">{title}</Text>

                    <div className="Content-Body">
                        <Text className="Content-Paragraph" type="body">{p1}</Text>
                        <Text className="Content-Paragraph" type="body">{p2}</Text>
                    </div>

                    <div onClick={this.handleConfirmClick}>
                        <Button
                            className="Button-CTA"
                            type="primary"
                            full={true}
                        >
                            {buttonTitle}
                        </Button>
                    </div>

                    <ListingActivationTerms
                        actionText={`By clicking ${buttonTitle}`}
                    />
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    modalEnableApplications: ModalSelectors.makeEnableApplicationsModal(state),
});

EnableApplicationsModal.propTypes = propTypes;
EnableApplicationsModal.defaultProps = defaultProps;

export { EnableApplicationsModal };
export default connect(mapStateToProps)(EnableApplicationsModal);
